import styled from 'react-emotion'

const MultiSelect = styled('div')(({ area }) => ({
  position: 'absolute',
  border: '1px solid #808080',
  background: 'rgba(128,128,128,0.2)',
  mixBlendMode: 'difference',
  ...area
}))

export default MultiSelect
